import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from 'react-router-dom';
import { State as ReceiptState } from '../reducer';
import Charts from './Charts';
import { Customer } from '../../../../types/customers';
import { Addresses } from '../../addresses';
import { Company } from '../../company';
import { Attributes } from '../../attributes';
import Contacts from './Contacts';

interface MatchParams {
    accountId: string;
    customerId: string;
}

export interface OverviewTabProps extends RouteComponentProps<MatchParams> {
    getLastReceipts: (accountId: string, customer_id: string) => void;
    receipts: ReceiptState;
    customer: Customer | undefined;
}

class OverviewTab extends Component<OverviewTabProps> {
    componentDidMount() {
        this.props.getLastReceipts(this.props.match.params.accountId, this.props.match.params.customerId);
    }

    render() {
        const { isLoading, receipts } = this.props.receipts;
        const { customer } = this.props;
        const { accountId, customerId } = this.props.match.params;
        return (
            <div>
                {customer && (
                    <Section>
                        <Contacts customer={customer} />
                    </Section>
                )}

                <Charts receipts={receipts} isLoading={isLoading} />

                {customer && (
                    <Section>
                        <Addresses
                            accountId={accountId}
                            customerId={customerId}
                            addresses={customer?.addresses || []}
                        />
                    </Section>
                )}

                {customer?.type === 'company' && (
                    <Section>
                        <Company accountId={accountId} customerId={customerId} company={customer.company} />
                    </Section>
                )}
                {customer?.attributes && (
                    <Section>
                        <Attributes accountId={accountId} customerId={customerId} attributes={customer?.attributes} />
                    </Section>
                )}
            </div>
        );
    }
}

const Section = styled.section`
    margin-top: 20px;
`;

export default OverviewTab;
